import ssFetch from '../../modules/ssFetch';

import type { ProviderScheduleCandidateRequestPayload } from '../../components/pages/FillScheduleGap/FillScheduleGap.types';

export async function getScheduleGap(token: string):
Promise<ProviderScheduleCandidateRequestPayload> {
  const url = `/schedule/provider_schedule_candidate/?token=${token}`;
  return ssFetch(url, {
    throwOnHttpError: true,
  }).then(res => res.json());
}
